import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import iconBYOC from '../../images/icons/icon_fordvehicle_yellow.png';

class TripInfo extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      slug,
      description,
      videoUrl,
      // recVehicle,
      isOwnVehicle,
      t,
      vehicleNo,
      isRaptor
    } = this.props;

    return (
      <section className='fe-trip-info'>
        <div className='container'>
          <div className='row position-relative'>
            <div className='col-lg-8'>
              {description !== '' ? (
                <div
                  className='fe-trip-main-desc'
                  dangerouslySetInnerHTML={{
                    __html: description
                  }}
                />
              ) : null}
              {videoUrl !== null && videoUrl !== '' ? (
                <div className="video-responsive">
                  <iframe
                    width="853"
                    height="480"
                    src={videoUrl}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Embedded youtube"
                  />
                </div>
              ) : null}
              {(slug === 'island-retreat-in-mantanani' || slug === 'beach-clean-up') ? null : (
                <div className='fe-trip-main-disclamer'>
                  {(slug === 'tabin-wildlife-safari-adventure' || slug === 'marine-life-of-mabul' || slug === 'escape-to-kapalai-paradise') ? <p>{t('gen:disclamerBookWithFordMalaysia')}</p> : (isRaptor ? <p>{t('gen:disclamerRaptor')}</p> : <p>{t('gen:disclamer')}</p>)}
                </div>
              )}
              <div className='fe-trip-main-vehicle'>
                <h4 className='fe-trip-main-heading'>
                  {/*isOwnVehicle
                    // ? t('gen:requirements')
                    ? null
                    : t('gen:recommendedRanger')*/}
                </h4>
                <div className='fe-trip-main-vehicle-img'>
                  {/* {!isOwnVehicle ? (
                    <div className='fe-trip-main-vehicle-thumb'>
                      <div className='fe-u-thumb-3by1'>
                        <img src={recVehicle.img_url} alt='' />
                      </div>
                    </div>
                  ) : null} */}
                  {!isOwnVehicle ? (
                    <div className='fe-trip-main-vehicle-info'>
                      {/* <h5 className='fe-trip-main-vehicle-name'>
                        {recVehicle.model}
                      </h5>
                      <div className='fe-trip-main-vehicle-desc'>
                        {recVehicle.subtext}
                      </div> */}
                    </div>
                  ) : null}
                  {/* (
                    <div className='fe-trip-main-vehicle-info byoc'>
                      <img src={iconBYOC} alt='' />
                      <h5 className='fe-trip-main-vehicle-name'>
                        {vehicleNo ? (
                          <>
                            {t('gen:vehicleNo')}
                            {vehicleNo}
                          </>
                        ) : (
                          <>{t('gen:bringOwnRanger')}</>
                        )}
                      </h5>
                    </div>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

TripInfo.propTypes = {
  slug: PropTypes.string,
  description: PropTypes.string,
  videoUrl: PropTypes.string,
  // recVehicle: PropTypes.object.isRequired,
  isOwnVehicle: PropTypes.bool,
  isRaptor: PropTypes.bool,
  t: PropTypes.func.isRequired
};

TripInfo.defaultProps = {
  description: ''
};

export default withTranslation()(TripInfo);
